// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__oYhOk","title":"styles_title__1w9HC","app":"styles_app__S8tq5","product":"styles_product__r5zOD","socialMedia":"styles_socialMedia__jEzUa"};